import request from '@/utils/request'

/**
 * 获取审核人员列表
 * @param {Object} params - 查询参数
 * @returns {Promise} 返回审核人员列表
 */
export function listAuditUsers(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/auditUserManage.list',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除审核人员
 * @param {Object} data - 删除参数
 * @returns {Promise} 返回删除结果
 */
export function deleteAuditUser(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/auditUserManage.delete',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}